import type { DashboardCampaignModel } from './dashboard.vm'

export type CampaignMenuCampaign = Pick<DashboardCampaignModel, 'status' | 'isArchived'>

export type CampaignMenuActions = {
	clone: boolean
	archive: boolean
	unarchive: boolean
}

const ARCHIVABLE_STATUSES: ReadonlyArray<CampaignMenuCampaign['status']> = ['draft', 'completed']

export function campaignMenuActions(
	campaign: CampaignMenuCampaign,
	can: (permission: string) => boolean,
): CampaignMenuActions {
	return {
		clone: !campaign.isArchived && can('campaign:create'),
		archive: !campaign.isArchived && ARCHIVABLE_STATUSES.includes(campaign.status) && can('campaign:update'),
		unarchive: campaign.isArchived && can('campaign:update'),
	}
}

export function hasAnyCampaignMenuAction(actions: CampaignMenuActions): boolean {
	return actions.clone || actions.archive || actions.unarchive
}
